import React, { useState, useEffect } from 'react';
import ProductList from './ProductList';
import Bseller from '../images/best_seller.png';
import Imgprdlist from '../images/product_list.png';


function Jfproduct() {
    const [isAcne, setIsAcne] = useState(1);
    const [isDerma, setIsDerma] = useState(0);

    const SetAcneProduct = () => {
        let isDerma = 0;
        let isAcne = 1;

        setIsDerma(isDerma);
        setIsAcne(isAcne);
    };

    const SetDermaProduct = () => {
        let isDerma = 1;
        let isAcne = 0;

        setIsDerma(isDerma);
        setIsAcne(isAcne);

        console.log(isDerma);
    };

    const [productAcne, SetProductAcne] = useState([]);
    const [productDerma, SetProductDerma] = useState([]);

    useEffect(() => {
        fetch('https://dev.jftheskinspecialist.com/api/acneproduct')
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                console.log(datas.data);
                SetProductAcne(datas.data);
        });

        fetch('https://dev.jftheskinspecialist.com/api/dermaproduct')
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                console.log(datas.data);
                SetProductDerma(datas.data);
            });
    }, []);


    return (
        <div id="acneproduct" class="max-w-full px-4 py-10 sm:px-6 lg:px-0 lg:py-0 mx-auto bg-[#fefaed]">
            <div class="max-w-7xl mx-auto">

                <div class="mb-0 py-10" style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                    <img src={Imgprdlist} alt="" />
                </div>

                {isAcne === 1 && (
                <section class="py-2 text-center">
                    <div class="mb-6">
                        <h3 class="text-[#ff8e35] font-bold text-2xl inline-block border-b-4 border-[#ff8e35] pb-2">
                            ACNE SERIES
                        </h3>
                            <span class="text-lg font-bold mx-4 bg-[#fba82a]">&nbsp;</span>
                        <h3 class="text-lg font-bold inline-block" onClick={() => SetDermaProduct()}>DERMA SERIES</h3>     
                    </div>
                    
                    <div class="max-w-full px-4 py-10 sm:px-6 lg:px-0 lg:py-0 mx-auto">
                        <div>
                            <img src={Bseller} className="object-none object-right-bottom w-98" style={{ paddingLeft: 60 }} alt="" />
                        </div><br />
                        <ProductList products={productAcne} />
                    </div>
                </section>
                )}

                {isDerma === 1 && (
                <section class="py-2 text-center">
                    <div class="mb-6">
                            <h3 class="font-bold text-lg inline-block" onClick={() => SetAcneProduct()}>ACNE SERIES
                        </h3>
                            <span class="text-lg font-bold mx-4 bg-[#fba82a]">&nbsp;</span>
                        <h3 class="text-[#ff8e35] text-2xl font-bold inline-block border-b-4 border-[#ff8e35] pb-2">DERMA SERIES</h3>
                    </div>
                    <div class="max-w-full px-4 py-10 sm:px-6 lg:px-0 lg:py-0 mx-auto">
                        <div>
                            <img src={Bseller} className="object-none object-right-bottom w-98" style={{ paddingLeft: 60 }} alt="" />
                        </div><br />
                            <ProductList products={productDerma} />
                    </div>
                </section>
                )}

            </div>
        </div>
    );
}

export default Jfproduct;
